import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Services = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const services = [
    {
      title: t('services.bioinformatics.title'),
      desc: t('services.bioinformatics.desc'),
      path: '/service/bioinformatics',
      icon: '🧬',
      tags: t('services.bioinformatics.tags', { returnObjects: true }),
    },
    {
      title: t('services.aiMl.title'),
      desc: t('services.aiMl.desc'),
      path: '/service/ai-ml',
      icon: '🤖',
      tags: t('services.aiMl.tags', { returnObjects: true }),
    },
    {
      title: t('services.consultancy.title'),
      desc: t('services.consultancy.desc'),
      path: '/service/consultancy',
      icon: '🔬',
      tags: t('services.consultancy.tags', { returnObjects: true }),
    },
    {
      title: t('services.scientificWriting.title'),
      desc: t('services.scientificWriting.desc'),
      path: '/service/scientific-writing',
      icon: '📝',
      tags: t('services.scientificWriting.tags', { returnObjects: true }),
    },
  ]

  return (
    <section className="relative py-16 sm:py-28 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <motion.div className="text-center mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <h2 className="text-4xl sm:text-5xl font-display font-bold tracking-tight text-text-main">
            {t('services.title.part1')}
            <br />
            <span className="text-gradient-green">{t('services.title.part2')}</span>
          </h2>
          <p className="mt-4 text-text-muted text-lg max-w-2xl mx-auto">
            {t('services.desc')}
          </p>
        </motion.div>

        {/* Service cards */}
        <div className="grid md:grid-cols-2 gap-5">
          {services.map((service, i) => (
            <motion.button
              key={i}
              onClick={() => navigate(service.path)}
              className="bio-card group p-5 sm:p-8 text-left"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <div className="text-4xl mb-5">{service.icon}</div>
              <h3 className="text-xl font-display font-bold mb-3 text-text-main group-hover:text-primary transition-colors">{service.title}</h3>
              <p className="text-text-muted text-sm leading-relaxed mb-5">{service.desc}</p>
              <div className="flex flex-wrap gap-2 mb-5">
                {service.tags.map((tag, j) => (
                  <span key={j} className="tag-pill">{tag}</span>
                ))}
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-all">
                {t('services.explore')} <ArrowRight className="w-4 h-4" />
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
